var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"viewbuttom"},[_vm._v("مشاهده دوره ها "),_c('b-icon',{staticClass:"mr-4",attrs:{"icon":"arrow-left-right"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }